/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { NavigationAnalyticsContext } from '@atlaskit/analytics-namespaced-context';

export default function AnalyticsWrapper({ children }: { children: ReactNode }): JSX.Element {
	return (
		<NavigationAnalyticsContext data={{ source: 'topNav' }}>{children}</NavigationAnalyticsContext>
	);
}
